import { useMemo, useState } from "react";

import { getCoreRowModel, useReactTable } from "@tanstack/react-table";

import { parseColumnsToResize } from "../tableResize/helper";

export function useTableResize({ columns = [], data = [] }) {
  const [columnSizing, setColumnSizing] = useState({})
  const [isFixedLayout, setIsFixedLayout] = useState(false)
  const parsedColumns = useMemo(() => parseColumnsToResize(columns), [columns])

  const table = useReactTable({
    data,
    columns: parsedColumns,
    getCoreRowModel: getCoreRowModel(),
    state: { columnSizing },
    onColumnSizingChange: setColumnSizing,
    columnResizeMode: 'onChange',
    columnResizeDirection: 'ltr',
  })

  return {
    ...table,
    isFixedLayout,
    setIsFixedLayout,
  }
}
